package xim.poc.game.configuration.v0.tactics

import xim.math.Vector2f
import xim.poc.AppendType
import xim.poc.MenuStacks
import xim.poc.UiElementHelper
import xim.poc.UiResourceManager
import xim.poc.game.ActorType
import xim.poc.gl.PortraitBufferManager
import xim.poc.ui.ShiftJis
import xim.resource.*

object TacticsUnitList {

    private const val fakeUiMenuName = "fake    unitlist"
    private var registered = false

    fun draw(match: TacticsMatchInstance) {
        UiElementHelper.enqueueDraw { drawInternal(match) }
    }

    private fun drawInternal(match: TacticsMatchInstance) {
        registerFakeMenu()

        val units = match.getSpeculativeTurnOrder().take(10)

        val result = UiElementHelper.drawMenu(
            menuName = fakeUiMenuName,
            menuStacks = MenuStacks.PartyStack,
            appendType = AppendType.HorizontalOnly,
        ) ?: return

        val offset = Vector2f(8f, 6f)

        for (entry in units) {
            UiElementHelper.drawUiElement(lookup = "menu    keytops3", index = 51, position = result + offset)

            val unit = entry.source
            val tacticsUnit = unit.getUnit()

            val nameColor = if (unit.type == ActorType.Enemy) { ShiftJis.colorInvalid } else { ShiftJis.colorWhite }
            val nameString = "${nameColor}${unit.name}${ShiftJis.colorClear}"

            val tpDelta = entry.speculativeTp - unit.getTp()
            val (tpColor, tpDeltaString) = if (tpDelta < 0) {
                ShiftJis.colorInfo to " ($tpDelta)"
            } else if (tpDelta > 0) {
                ShiftJis.colorAug to " (+$tpDelta)"
            }else {
                ShiftJis.colorWhite to ""
            }

            val tpString = "TP: ${tpColor}${entry.speculativeTp}${tpDeltaString}${ShiftJis.colorClear}"

            UiElementHelper.drawString("${nameString}\n${tpString}", result + offset + Vector2f(38f, 3f))

            val portrait = PortraitBufferManager.getTakenPhoto(unit.id)
            if (portrait != null) {
                val portraitElement = UiElement.basicSquare(portrait.name, size = 32, uvHeight = 64, uvWidth = 64, flipMode = UiFlipMode.Vertical)
                val internalQuality = entry.source.getUnitConfig()?.internalQuality ?: 0

                UiElementHelper.drawCustomBorder(result + offset + Vector2f(), customBorder = internalQuality)
                UiElementHelper.drawUiElement(portraitElement, result + offset + Vector2f(1f, 0f))
            }

            offset.y += 40f
        }
    }

    private fun registerFakeMenu() {
        if (registered) { return }
        registered = true

        val originalMenu = UiResourceManager.getMenu("menu    raid2   ") ?: throw IllegalStateException("Couldn't find 'menu    helpwind'")

        val fakeMenu = UiMenu(fakeUiMenuName, originalMenu.uiMenu.frame.deepCopy(), emptyList())
        fakeMenu.frame.offset.y -= 80f
        fakeMenu.frame.size.y = 420f
        fakeMenu.frame.size.x = 160f

        UiResourceManager.register(UiMenuResource(DatId.zero, fakeMenu))
    }

}